import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./search-deed-transfer-date.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./search-deed-transfer-date.component.scss?ngResource";
import { Component, Input } from "@angular/core";
import { NgbCalendar, NgbDate, NgbDateParserFormatter } from "@ng-bootstrap/ng-bootstrap";
import { ApplicationSearchConstants } from "../../../application-search-constants";
import { FormControl, FormGroup } from "@angular/forms";
import { ApplicationSearchService } from "../../../../shared/application-search.service";
import { AflaModuleStrategyService } from "../../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SaShortDatePipe } from "../../../../../../shared/pipes/sa-short-date/sa-short-date.pipe";
import { SharedConstants } from "../../../../../../shared/constants/shared.constants";
import { AlertType } from "../../../../../../shared/models/alert";
import { AppControllerService } from "../../../../../../app-controller.service";
let SearchDeedTransferDateComponent = class SearchDeedTransferDateComponent {
    calendar;
    formatter;
    applicationSearchService;
    aflaModuleStrategyService;
    saShortDatePipe;
    appController;
    noOfMonthsToDisplay;
    deedTransferDateFormControl = ApplicationSearchConstants.FORM_CONTROLS.deedTransferDateFormControl;
    deedTransferBeforeDateFormControl = ApplicationSearchConstants.FORM_CONTROLS.deedTransferBeforeDateFormControl;
    deedTransferAfterDateFormControl = ApplicationSearchConstants.FORM_CONTROLS.deedTransferAfterDateFormControl;
    beforeDateLabel = ApplicationSearchConstants.FORM_CONTROLS.beforeDateLabel;
    searchText = ApplicationSearchConstants.FORM_CONTROLS.searchText;
    datePlaceholder = ApplicationSearchConstants.FORM_CONTROLS.datePlaceholder;
    afterDateLabel = ApplicationSearchConstants.FORM_CONTROLS.afterDateLabel;
    deedTransferBeforeDate;
    deedTransferAfterDate;
    deedTransferDateForm;
    applicationSearchCallback;
    isSelectedToDate = false;
    isDisabledToCreatedDate = true;
    hoveredDate = null;
    constructor(calendar, formatter, applicationSearchService, aflaModuleStrategyService, saShortDatePipe, appController) {
        this.calendar = calendar;
        this.formatter = formatter;
        this.applicationSearchService = applicationSearchService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.saShortDatePipe = saShortDatePipe;
        this.appController = appController;
        // this.deedTransferBeforeDate = calendar.getToday();
        // this.deedTransferAfterDate = calendar.getToday();
    }
    ngOnInit() {
        this.setUpForm();
    }
    searchApplication($event) {
        const afterDate = this.deedTransferAfterDate ? new Date(this.deedTransferAfterDate.year, this.deedTransferAfterDate.month - 1, this.deedTransferAfterDate.day) : null;
        if (afterDate)
            afterDate.setDate(afterDate.getDate() - 2);
        const beforeDate = this.deedTransferBeforeDate ? new Date(this.deedTransferBeforeDate.year, this.deedTransferBeforeDate.month - 1, this.deedTransferBeforeDate.day)
            : null;
        if (beforeDate)
            beforeDate.setDate(beforeDate.getDate() - 1);
        this.applicationSearchCallback(this.applicationSearchService.searchByDeedTransferDate(Number(this.appController.selectedModuleID), this.aflaModuleStrategyService, afterDate ? this.saShortDatePipe.transform(afterDate) : null, beforeDate ? this.saShortDatePipe.transform(beforeDate) : null));
    }
    // to be consistent, user must click 'Search' before we trigger the search for applications
    onDateSelection(date, dateCtrl) {
        if (dateCtrl === "afterDate")
            this.deedTransferAfterDate = date;
        else
            this.deedTransferBeforeDate = date;
    }
    clearDate(dateCtrl) {
        if (dateCtrl === "afterDate")
            this.deedTransferAfterDate = null;
        else
            this.deedTransferBeforeDate = null;
    }
    setAutoClose() {
        return "'outside'";
    }
    isHovered(date) {
        return false;
    }
    isInside(date) {
        return false;
    }
    isRange(date) {
        return false;
    }
    validateInput(currentValue, input) {
        const parsed = this.formatter.parse(input);
        if (!parsed && input !== "") {
            this.appController.showMessage(`${SharedConstants.DATE_INPUT_CONTROL_VALIDATION}`, AlertType.Warning);
            return currentValue;
        }
        return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
    }
    setUpForm() {
        this.deedTransferDateForm = new FormGroup({
            deedTransferAfterDateFormControl: new FormControl(null),
            deedTransferBeforeDateFormControl: new FormControl(null)
        });
    }
    static ctorParameters = () => [
        { type: NgbCalendar },
        { type: NgbDateParserFormatter },
        { type: ApplicationSearchService },
        { type: AflaModuleStrategyService },
        { type: SaShortDatePipe },
        { type: AppControllerService }
    ];
    static propDecorators = {
        noOfMonthsToDisplay: [{ type: Input }]
    };
};
SearchDeedTransferDateComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-search-deed-transfer-date",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], SearchDeedTransferDateComponent);
export { SearchDeedTransferDateComponent };
